var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{attrs:{"type":"card-full"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('menu-btn',{attrs:{"menuid":_vm.menuid,"btnLoading":_vm.btnLoading},on:{"btnClick":_vm.btnClick}})],1),_c('div',{staticStyle:{"color":"red"}},[_vm._v("即将推出,敬请期待")])])
}
var staticRenderFns = []

export { render, staticRenderFns }